// index reducer, one reducer to rule them all

import { combineReducers } from 'redux';

import app from './app.reducer';
import partnerReducer from './partner';
import commonReducer from './common';
import authenticationReducer from './authentication';

const rootReducer = combineReducers({
  app,
  rewards: partnerReducer,
  common: commonReducer,
  authentication: authenticationReducer,
});

export default rootReducer;
